import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31230f1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-small-card-wrap" }
const _hoisted_2 = { class: "block-small-card" }
const _hoisted_3 = { class: "block-small-card-text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'block-small-card',
  props: {
  /** Заголовок  */
  text: {
    type: String,
    default: "",
  },  
  link: {
    type: String,
    default: "",
  },
  image: {
    type: String,
    default: "",
  },
  imageOnPhone: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    default: "250px",
  },
  width: {
    type: String,
    default: "408px",
  },

},
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "16667549": (__props.width),
  "c6cd8bf8": (__props.height)
}))



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["block-small-card-image", { 'block-small-card-image_phone': __props.imageOnPhone }])
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle({backgroundImage:'url('+__props.image+')'}),
          class: "small-card-image"
        }, null, 4),
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: {name:__props.link},
          class: "block-small-card-text"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.text), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})